import {
  ChatText,
  Info,
  UsersThree,
} from "@phosphor-icons/react";
import CallEndIcon from "@mui/icons-material/CallEnd";
import ControlButton from "../../../../components/ControlButtom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { InfoOutlined } from "@mui/icons-material";
import { getLanguageTexts, getSelectedLanguage } from "../../../../language";

export default function VideoAreaBottomControlls({
  // streaming control
  localStream,
  enableVideoStream,
  handleEnableVideoStream,
  enableAudioStream,
  handleEnableAudioStream,
  isShareScreen,
  handleStartScreenShare,
  handleDisconnectScreenShare,
  handleDisconnect,
  closeCall,
  // right content control
  show_chat,
  setShowChat,
  show_info,
  setShowInfo,
  show_participants,
  setShowParticipants,
  processo
}) {
  const [last_messages,setLastMessages] = useState([]);
  const [show_warning,setShowWarning] = useState(false);
  const user = useSelector(store=>store.AppReducer.user);
  const mensagens = useSelector(store=>store.AppReducer.mensagens);
  const t = getLanguageTexts(getSelectedLanguage());

  useEffect(()=>{
    if(last_messages.length==0){
      setLastMessages(mensagens)
    }
    else if(last_messages.length!=mensagens.length){
      setLastMessages(mensagens)
      if(show_chat==false){
        setShowWarning(true);
      }
    }
  },[mensagens]);
  return (
    <div
      hidden={user?.accessibility==true && user?.type_supervisor!='none' && processo.is_interview==false}
      style={{
        height: "max-content",
        width: "100%",
        display: "flex",
        gap: "1rem",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: "1.4rem",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "1rem",
        }}
      >
        <div style={{
              padding: '0.1rem',
              height: 56,
              width: 56,
              objectFit: 'cover',
              borderRadius: '1rem',
              background:'orange',
              display:'flex',
              justifyContent:'center',
              alignItems:'center'
        }}>
          <p style={{marginBottom:0,textAlign:'center',color:'white'}}>{user?.name?.toUpperCase().substring(0,2)}</p>

        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "1rem",
        }}
      >
        <ControlButton
          tooltip={t.leave_call}
          icon={
            <CallEndIcon
              sx={{
                color: "#fc3d3d",
              }}
            />
          }
          onClick={()=>handleDisconnect()}
        />
      </div>

      <div
        style={{
          display: "flex",
          gap: "1rem",
        }}
      >
        <div style={{position:'relative'}}>
        <ControlButton
          tooltip={show_chat ? t.hide_chat : t.show_chat}
          icon={show_chat ? <ChatText weight="fill" /> : <ChatText />}
          onClick={() => {
            if (show_participants) setShowParticipants(false);
            if (show_info) setShowInfo(false);
            setShowChat(!show_chat);
            setShowWarning(false);
          }}
        />
         {show_warning && <div style={{width:20,height:20,background:'green',top:-5,right:-5,position:'absolute',borderRadius:100}}>

</div>}
</div>
        <ControlButton
          tooltip={
            show_participants
              ? t.hide_participants
              : t.show_participants
          }
          icon={
            show_participants ? <UsersThree weight="fill" /> : <UsersThree />
          }
          onClick={() => {
            if (show_chat) setShowChat(false);
            if (show_info) setShowInfo(false);

            setShowParticipants(!show_participants);
          }}
        />
        <ControlButton
          tooltip={
            show_info
              ? t.hide_information
              : t.show_information
          }
          icon={
            show_info ? <Info weight="fill" /> : <InfoOutlined />
          }
          onClick={() => {
            if (show_chat) setShowChat(false);
            if (show_participants) setShowParticipants(false);

            setShowInfo(!show_info);
          }}
        />
      </div>
    </div>
  );
}
